import styled from 'styled-components';

export const BlankButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0px;
  margin: 0px;
  padding: 0px;
  background-color: transparent;
`;
